import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Background } from "../common/components";
import { TextL, TextXL } from "../common/text";
import {
  KakaoLoginButton,
  KakaoLogo,
  LoginWrapper,
  LoginHeader,
  LoginHeaderText,
  AccountLogin,
  Register,
  Email,
  PasswordWrapper,
  LoginHeaderLogo,
  KakaoTextWrapper,
  PasswordInput,
  KaKaoLogoWrapper,
} from "./Login.styles";
import { Helmet } from "react-helmet";
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { KAKAO_LOGIN_LOGO, LOGIN_LOGO_SRC, useLogin } from "./Login.helpers";

const Login = () => {
  const onClickKakaoLogin = () => {
    if (process.env.REACT_APP_MODE === "prod") {
      window.location.href =
        "https://next-energy.kr:8129/api/auth/oauth2/authorization/kakao";
    } else if (process.env.REACT_APP_MODE === "dev") {
      window.location.href =
        "http://localhost:8129/api/auth/oauth2/authorization/kakao";
    }
  };

  const [email, setEmail] = useState("");
  const onEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const [password, setPassword] = useState("");
  const onPasswordChange = (e) => {
    setPassword(e.target.value);
  };
  const navigate = useNavigate();
  const { mutate: login } = useLogin();
  const goToRegister = () => {
    navigate("/register");
  };
  const goToFindAccount = () => {
    navigate("/find-account");
  };

  const onClickLogin = () => {
    if (email && password) {
      login({ username: email, password });
    } else {
      alert("로그인 정보를 모두 입력해주세요");
    }
  };

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Background>
      <Helmet>
        <title>넥스트에너지</title>
      </Helmet>
      <LoginHeader>
        <LoginHeaderLogo src={LOGIN_LOGO_SRC}></LoginHeaderLogo>
        <LoginHeaderText>NextEnergy</LoginHeaderText>
      </LoginHeader>
      <LoginWrapper>
        <Email
          onChange={onEmailChange}
          value={email}
          placeholder={"이메일"}
          variant="standard"
        />
        <PasswordWrapper variant="standard">
          <PasswordInput
            id="standard-adornment-password"
            type={showPassword ? "text" : "password"}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            placeholder={"비밀번호"}
            onChange={onPasswordChange}
          />
        </PasswordWrapper>

        <AccountLogin onClick={onClickLogin}>
          <TextXL color="white">로그인</TextXL>
        </AccountLogin>

        <KakaoLoginButton onClick={onClickKakaoLogin}>
          <KaKaoLogoWrapper>
            <KakaoLogo src={KAKAO_LOGIN_LOGO} />
          </KaKaoLogoWrapper>
          <KakaoTextWrapper>
            <TextL>카카오톡으로 시작하기</TextL>
          </KakaoTextWrapper>
        </KakaoLoginButton>
        <Register>
          <a onClick={goToFindAccount}>
            <u>나의 계정 찾기</u>
          </a>
          <b> | </b>
          <a onClick={goToRegister}>
            <u>회원가입</u>
          </a>
        </Register>
      </LoginWrapper>
    </Background>
  );
};

export default Login;
